import { Theme, makeStyles } from "@material-ui/core";
import { IRemoLogoProps } from "./RemoLogo";

export const useStyles = makeStyles<Theme, IRemoLogoProps>(() => ({
  root: {
    display: "block",
    width: (props) => (props.size === "lg" ? 103 : 40),
  },
  customWidth: {
    width: (props) => props.width,
  },
}));
